import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import qs from 'qs';

import { confirmUser } from '../actions/user';

class Confirmation extends Component {
  state = {
    confirmed: false
  };

  componentDidMount() {
    const { confirmation_token } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (confirmation_token) {
      this.props._confirmUser(confirmation_token).then(() => {
        this.setState({ confirmed: true });
      }).catch(() => {
        this.setState({ confirmed: true });
      });
    } else {
      this.setState({ confirmed: true });
    }
  }

  render() {
    if (this.state.confirmed) {
      return <Redirect to="/" />;
    }
    return null;
  }
}

const mapDispatchToProps = dispatch => ({
  _confirmUser: confirmation_token => dispatch(confirmUser(confirmation_token)),
});

export default withRouter(connect(null, mapDispatchToProps)(Confirmation));
